import { useEffect } from 'react';

export function useContentProtection() {
  useEffect(() => {
    // Bloqueia botão direito
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    // Bloqueia teclas de atalho (F12, Ctrl+U, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+S)
    const handleKeyDown = (e: KeyboardEvent) => {
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
        return;
      }
      // Ctrl+U (ver código fonte)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        return;
      }
      // Ctrl+Shift+I (DevTools)
      if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
        return;
      }
      // Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.key === 'J') {
        e.preventDefault();
        return;
      }
      // Ctrl+Shift+C (Inspect element)
      if (e.ctrlKey && e.shiftKey && e.key === 'C') {
        e.preventDefault();
        return;
      }
      // Ctrl+S (salvar página)
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        return;
      }
      // Ctrl+A (selecionar tudo)
      if (e.ctrlKey && e.key === 'a') {
        e.preventDefault();
        return;
      }
      // Ctrl+C (copiar)
      if (e.ctrlKey && e.key === 'c') {
        e.preventDefault();
        return;
      }
      // Ctrl+P (imprimir)
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
        return;
      }
    };

    // Bloqueia seleção de texto
    const handleSelectStart = (e: Event) => {
      e.preventDefault();
    };

    // Bloqueia drag de imagens/texto
    const handleDragStart = (e: DragEvent) => {
      e.preventDefault();
    };

    // Bloqueia cópia via clipboard
    const handleCopy = (e: ClipboardEvent) => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('selectstart', handleSelectStart);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('copy', handleCopy);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('selectstart', handleSelectStart);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('copy', handleCopy);
    };
  }, []);
}
